var loadScriptWithCallback = function loadScriptWithCallback(url, callback) {
  return new Promise(function (resolve) {
    window[callback] = function () {
      return resolve();
    };

    var script = document.createElement('script');
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
};

export default loadScriptWithCallback;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/loadScriptWithCallback.js
// module id = null
// module chunks = 